// @ts-nocheck
import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import constants from "@store/constants";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";

const getSampleProductInfo = (productInfo: ProductInfo) => {
    try {
        const samplePricing = productInfo.pricing?.additionalResults?.sampleItemData;
        const sampleInventory = productInfo.inventory?.additionalResults?.sampleItemData;

        if (samplePricing || sampleInventory) {
            return mergeProps(productInfo, {
                pricing: samplePricing ? JSON.parse(samplePricing) : undefined,
                inventory: sampleInventory ? JSON.parse(sampleInventory) : undefined,
                unitOfMeasure: constants.sampleUOM,
            } as ProductInfo);
        }
    } catch (error) {
        // Keep original productInfo
    }

    return productInfo;
};

export default getSampleProductInfo;
